import React from "react";

const Landingpagecover = (props) => {
  return (
    <div>
      <div className="cover">{props.children}</div>
    </div>
  );
};

export default Landingpagecover;
